<template>
  <section class="height-100-p">
    <el-table
      ref="searchSummaryMyInvoicesTable"
      :data="invoices.list"
      v-loading="invoices.loadingSearch"
      id="invoices-data-list"
      size="mini"
      tooltip-effect="dark"
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
      :select-on-indeterminate="false"
      stripe
      @select-all="handleSelectAllToBulkPrint"
      @select="handleSelectSingleToBulkPrint"
    >
      <el-table-column
          :label="$t('outbound.loads.origin')"
          :min-width="3"
          align="center">
        <template slot-scope="scope">
          <span> {{ scope.row.origin }} </span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('invoices.invoiceNum')"
        :min-width="10"
        align="center">
        <template slot-scope="scope">
          <span> {{ scope.row.number }} </span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('invoices.date')"
        :min-width="10"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.date | moment("MM/DD/YYYY") }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('invoices.company')"
        :min-width="15"
        align="left"
        header-align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.billToAccountName + ' - ' + scope.row.billToAccountNumber" placement="top">
            <span> {{scope.row.billToAccountName}} - {{ scope.row.billToAccountNumber }} </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('invoices.type')"
        :min-width="7"
        align="center">
        <template slot-scope="scope">
          <span> {{ getNameOfInvoiceType(scope.row.type) }} </span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('invoices.totalAmount')"
        :min-width="10"
        align="center">
        <template slot-scope="scope">
          <span>{{ getAmount(scope.row.totalAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!invoices.isInBulkPrinting"
        width="130"
        :label="$t('common.options')"
        align="center"
        class-name="fixed-width">
        <template slot-scope="scope" v-if="!invoices.isInBulkPrinting">
          <print-invoice :id ="scope.row.id" :invoice-type="scope.row.type" :show-type="'Button'"/>
        </template>
      </el-table-column>
      <!-- V-if does not works correctly in dynamic column of type selection, we need to do a little hack with v-for -->
      <el-table-column
        v-for="i in (invoices.isInBulkPrinting)? [1]: []" :key="i"
        type="selection"
        align="center"
        width="130"
      >
      </el-table-column>
    </el-table>
    <div class="pagination-footer" v-show="invoices.total > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title"> {{ $t('common.total') }}</span>
           {{ invoices.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="invoices.actualFilters.rows"
        :current-page.sync="invoices.actualFilters.page"
        @current-change="handleSearchChangePage"
        :total="invoices.total"
        layout="sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import PrintInvoice from '../components/PrintInvoice';

export default {
  name: 'MyInvoicesSummarySection',
  computed: {
    ...mapGetters(['invoices']),
    sizes() {
      return constants.TABLES.DEFAULT_LIMIT_SIZES;
    },
  },
  watch: {
    'invoices.list': function wacthInvoiceList() {
      if (this.invoices.isInBulkPrinting) {
        let listToCheck;
        if (this.invoices.selectAllChecked) {
          listToCheck = this.invoices.list.filter(invoiceLocal => !this.invoices.selectedIdsExcluded.includes(invoiceLocal.id));
        } else {
          listToCheck = this.invoices.list.filter(invoiceLocal => this.invoices.selectedIdsIncluded.includes(invoiceLocal.id));
        }
        this.$nextTick(() => {
          listToCheck.forEach(row => this.$refs.searchSummaryMyInvoicesTable.toggleRowSelection(row));
        });
      }
    },
    'invoices.isInBulkPrinting': function wacthInvoiceIsInBulkPrinting() {
      this.$refs.searchSummaryMyInvoicesTable.clearSelection();
    }
  },
  components: {
    PrintInvoice
  },
  methods: {
    handleSearchChangeLimit(val) {
      this.$store.dispatch('invoices/searchMyInvoices', { rows: val, page: constants.TABLES.DEFAULT_PAGE });
    },
    handleSearchChangePage(val) {
      this.$store.dispatch('invoices/searchMyInvoices', { page: val });
    },
    getNameOfInvoiceType(numType) {
      return constants.INVOICE.TYPES.find(type => type.value === numType).label;
    },
    getAmount(amount) {
      if (amount < 0) {
        return `(${this.$options.filters.currency(amount).replace('-', '')})`;
      }
      return this.$options.filters.currency(amount);
    },
    handleSelectAllToBulkPrint(selection) {
      this.$store.dispatch('invoices/toggleBulkPrintAllChecked', selection && selection.length > 0);
    },
    handleSelectSingleToBulkPrint(selection, row) {
      this.$store.dispatch('invoices/toggleBulkPrintSingleCheck', row.id);
    }
  },
  beforeDestroy() {
    this.$store.dispatch('invoices/clearList');
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.el-table-column--selection, th, td {
  transition: 2.2s;
  transition-timing-function: ease-in;
}
</style>
